import React from 'react';
import DOMPurify from 'dompurify';
import { Wrapper } from './RichText.styled';

/**
 * Allowlist estricto: exactamente lo que el editor de noticias produce (más
 * <h3> y <a> por contenido histórico). Todo lo demás se degrada a texto y
 * cualquier atributo fuera de la lista (handlers on*, style, src…) se elimina.
 * DOMPurify además descarta esquemas peligrosos como javascript: en href.
 */
const SANITIZE_CONFIG = {
  ALLOWED_TAGS: ['p', 'strong', 'em', 'h1', 'h2', 'h3', 'ul', 'ol', 'li', 'a', 'br'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
};

// Los links siempre abren en pestaña nueva con rel seguro. El hook corre
// después de la limpieza de atributos, así que sus valores sobreviven.
DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

type RichTextProps = {
  /** HTML del editor de noticias; se sanitiza aquí mismo antes de renderear. */
  html: string;
};

/** Render seguro del HTML de una noticia con la tipografía de la app. */
const RichText = ({ html }: RichTextProps) => (
  // eslint-disable-next-line react/no-danger
  <Wrapper dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html, SANITIZE_CONFIG) }} />
);

export default RichText;
